import { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X, Download } from "lucide-react";
import { useTestFlight } from "@/context/TestFlightContext";

// Launch Day Kit — invisible while the app is in Apple review. The day
// REACT_APP_TESTFLIGHT_STATUS flips to "live" (with REACT_APP_TESTFLIGHT_URL set),
// this slim bar appears site-wide above the navbar and every CTA on the site
// switches to the real App Store/TestFlight flow at the same time.
// Preview the launch-day state anytime by appending ?launch=live to any URL.
export default function LaunchBanner() {
  const { testFlightReady } = useTestFlight();
  const [dismissed, setDismissed] = useState(
    () =>
      typeof window !== "undefined" &&
      localStorage.getItem("launch-banner-dismissed") === "1"
  );

  if (!testFlightReady || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem("launch-banner-dismissed", "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="launch-banner"
      className="bg-gradient-to-r from-neon-violet to-neon-cyan"
    >
      <div className="container-x relative flex items-center justify-center gap-2.5 h-10 px-10">
        <Sparkles className="w-3.5 h-3.5 text-white shrink-0 hidden sm:block" />
        <p className="text-white text-xs sm:text-sm font-medium truncate">
          GateMate is live on the App Store and Google Play.
        </p>
        <Link
          to="/download"
          data-testid="launch-banner-download"
          className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-black/85 hover:bg-black text-white text-xs font-semibold px-3.5 py-1.5 transition-colors"
        >
          <Download className="w-3 h-3" /> Download
        </Link>
        <button
          onClick={dismiss}
          aria-label="Dismiss launch announcement"
          data-testid="launch-banner-dismiss"
          className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 grid place-items-center w-7 h-7 rounded-full text-white/70 hover:text-white hover:bg-black/20 transition-colors"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
